import { SET_LXW_LOCALSTORAGE_VALUE } from "./types";
import { TRASH_LIFECYCLE_STATUS } from "../utilities/lifecycleStatus";

function toggleValue(key) {
	return function (dispatch, getState) {
		const { browserLocalstorage } = getState();
		const newValue = !browserLocalstorage[key];
		setLocalstorageValue(key, newValue)(dispatch);
	};
}

export function setLocalstorageValue(key, value) {
	return function (dispatch) {
		dispatch({ type: SET_LXW_LOCALSTORAGE_VALUE, payload: { key, value } });
	};
}
export const setDocumentListShowTrash = (value) =>
	setLocalstorageValue("documentListShowTrash", value);
export const toggleDocumentListShowTrash = () =>
	toggleValue("documentListShowTrash");
export const setDocumentListShowArchive = (value) =>
	setLocalstorageValue("documentListShowArchive", value);
export const toggleDocumentListShowArchive = () =>
	toggleValue("documentListShowArchive");

export const toggleShowTrashMatters = () => toggleValue("showTrashMatters");
export const toggleShowArchiveMatters = () => toggleValue("showArchiveMatters");

export const toggleShowTrashClients = () => toggleValue("showTrashClients");

export function toggleSidenav() {
	return toggleValue("sidenavExpanded");
}
export function toggleTopMattersSearchResults() {
	return toggleValue("topMattersSearchResultsExpanded");
}
export function toggleMatterInfo() {
	return toggleValue("matterInfoHidden");
}
export function toggleNewDocumentProfilingExpanded() {
	return toggleValue("newDocumentProfilingExpanded");
}
export function toggleMandatoryProfilingDialogBulkProcessing() {
	return toggleValue("mandatoryProfilingDialogBulkProcessingExpanded");
}
export function toggleAiGroupSourcesByMessage() {
	return toggleValue("aiGroupSourcesByMessage");
}
export function toggleAiCitationsSidebar() {
	return toggleValue("aiCitationsSidebarCollapsed");
}
export function togglePasswordProtectShare() {
	return toggleValue("passwordProtectShare");
}
export function updateWhatsNewDropdownLastHashViewed(currentWhatsNewItemsHash) {
	return setLocalstorageValue(
		"whatsNewDropdownLastHashViewed",
		currentWhatsNewItemsHash
	);
}
export function updateDraftableComparisonIdentifier(
	draftableComparisonIdentifier
) {
	return setLocalstorageValue(
		"draftableComparisonIdentifier",
		draftableComparisonIdentifier
	);
}
export function updateInlineCompareUrl(inlineCompareUrl) {
	return setLocalstorageValue("inlineCompareUrl", inlineCompareUrl);
}
export function toggleDropdownSelectShowAll(dropdownKey) {
	return function (dispatch, getState) {
		const { browserLocalstorage } = getState();

		let newState = { ...browserLocalstorage.dropdownSelectShowAll };
		const currentVal = newState[dropdownKey];
		newState[dropdownKey] = !currentVal;

		return setLocalstorageValue(
			"dropdownSelectShowAll",
			newState
		)(dispatch);
	};
}

function updateRecentlyViewed(key, id, lifecycleStatus) {
	return function (dispatch, getState) {
		if (!id || lifecycleStatus === TRASH_LIFECYCLE_STATUS) {
			return;
		}
		const idString = String(id);
		const recentlyViewed = getState().browserLocalstorage[key] || [];
		if (recentlyViewed.indexOf(idString) === 0) {
			return;
		}
		const newRecentlyViewed = [
			idString,
			...recentlyViewed.filter((existingID) => existingID !== idString),
		].slice(0, 20);
		return setLocalstorageValue(key, newRecentlyViewed)(dispatch);
	};
}

function getRecentlyViewed(key) {
	return function (dispatch, getState) {
		return getState().browserLocalstorage[key] || [];
	};
}

export const updateRecentlyViewedMatters = (matterID, lifecycleStatus) =>
	updateRecentlyViewed("recentlyViewedMatters", matterID, lifecycleStatus);
export const getRecentlyViewMatters = () =>
	getRecentlyViewed("recentlyViewedMatters");

export const updateRecentlyViewedClients = (clientID, lifecycleStatus) =>
	updateRecentlyViewed("recentlyViewedClients", clientID, lifecycleStatus);
export const getRecentlyViewedClients = () =>
	getRecentlyViewed("recentlyViewedClients");
